export const BOHDISYS_API_URL = "https://staging-api.bodhisys.io";
export const BOHDISYS_BASE_URL = "https://staging-api.bodhisys.io";